import { render, staticRenderFns } from "./EditSettingDialog.vue?vue&type=template&id=959340b8&"
import script from "./EditSettingDialog.vue?vue&type=script&lang=ts&"
export * from "./EditSettingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports